import styled from 'styled-components';
import { useReportContext } from '../../../../context/DetailContext';
import { Renter } from '../../data';
import { ReportFormatNumber } from '../../../../func/Function';
import { useEffect, useState } from 'react';

interface Props {
  renterInfo: Renter[];
  pRenterInfo?: any;
  rentNote: string[];
  appraisalInfo: {
    appraise_date: string;
    appraiser: string;
    lessee_date: string;
  };
}

const renderMapping = {
  renter: '임차인',
  deposit: '보증금/차임(월세)',
  rpart: '전입/확정/배당',
  regDate: '대항력/기타',
};

const TenantStatus = ({ renterInfo, rentNote, appraisalInfo }: Props) => {
  const { type } = useReportContext();
  const [newRentNote, setNewRentNote] = useState<string[]>([]);
  const [showAll, setShowAll] = useState<boolean>(false);
  useEffect(() => {
    if (rentNote.length > 0) {
      setNewRentNote(rentNote[0].split('<br>'));
    } else {
      setNewRentNote(['-']);
    }
  }, []);

  const renderData = (item: any) => {
    if (item.renter === '===== 조사된 임차내역 없음 =====') {
      return (
        <tbody>
          <TableTr isFirst={true} isOneRow={true}>
            <TableHeadTh width={'72px'}>임차인</TableHeadTh>
            <TableHeadTh width={'72px'}>
              보증금/
              <br />
              차임(월세)
            </TableHeadTh>
            <TableHeadTh width={'72px'}>
              전입/
              <br />
              확정/
              <br />
              배당
            </TableHeadTh>
            <TableHeadTh width={'72px'}>
              대항력/
              <br />
              기타
            </TableHeadTh>
          </TableTr>
          <TableTr>
            <TableTd colSpan={4} width="80%">
              해당 내용 없음
            </TableTd>
          </TableTr>
        </tbody>
      );
    } else if (
      item.renter ===
      '===== 임차인이 없으며 전부를 소유자가 점유 사용합니다. ====='
    ) {
      return (
        <tbody>
          <TableTr isFirst={true} isOneRow={true}>
            <TableHeadTh width={'72px'}>임차인</TableHeadTh>
            <TableHeadTh width={'72px'}>
              보증금/
              <br />
              차임(월세)
            </TableHeadTh>
            <TableHeadTh width={'72px'}>
              전입/
              <br />
              확정/
              <br />
              배당
            </TableHeadTh>
            <TableHeadTh width={'72px'}>
              대항력/
              <br />
              기타
            </TableHeadTh>
          </TableTr>
          <TableTr>
            <TableTd colSpan={4} width="80%">
              임차인이 없으며 전부를 소유자가 점유 사용합니다.
            </TableTd>
          </TableTr>
        </tbody>
      );
    } else if (item.renter.includes('☞')) {
      return (
        <tbody>
          <TableTr isFirst={true} isOneRow={true}>
            <TableHeadTh width={'72px'}>임차인</TableHeadTh>
            <TableTd rowSpan={3} width="80%" style={{ textAlign: 'left' }}>
              {(() => {
                try {
                  // item.renter가 null, undefined 또는 빈 문자열인지 확인
                  if (!item.renter || typeof item.renter !== 'string') {
                    return <span>{item.renter}</span>;
                  }

                  // '☞'로 split하고 map을 사용하여 출력
                  return item.renter
                    .split('☞')
                    .map((part: any, index: number) => {
                      return (
                        <span key={index}>
                          {index > 0 && '☞'}
                          {part}
                          <br />
                        </span>
                      );
                    });
                } catch (error) {
                  console.error('오류 발생:', error);
                  return <span>{item.renter}</span>;
                }
              })()}
            </TableTd>
          </TableTr>
          <TableTr isOneRow={true}>
            <TableHeadTh width={'72px'}>
              보증금
              <br />
              /차임
              <br />
              (월세)
            </TableHeadTh>
            {/* <TableTd width="100%"></TableTd> */}
          </TableTr>
          <TableTr isOneRow={true}>
            <TableHeadTh width={'72px'}>
              전입/
              <br />
              확정/
              <br />
              배당
            </TableHeadTh>
            {/* <TableTd width="100%"></TableTd> */}
          </TableTr>
          <TableTr>
            <TableHeadTh width={'72px'}>
              대항력/
              <br />
              기타
            </TableHeadTh>
            {/* <TableTd width="100%"></TableTd> */}
          </TableTr>
        </tbody>
      );
    } else {
      return (
        <tbody>
          <TableTr isFirst={true}>
            <TableHeadTh width={'72px'}>임차인</TableHeadTh>
            <TableTd rowSpan={1} width="80%">
              {item.renter}
            </TableTd>
          </TableTr>
          <TableTr>
            <TableHeadTh width={'72px'}>
              보증금
              <br />
              /차임
              <br />
              (월세)
            </TableHeadTh>
            <TableTd width="80%">
              {item.deposit === '-' && item.monthlyRentPay === '-' ? (
                '-'
              ) : (
                <>
                  {ReportFormatNumber(Number(item.deposit))} / <br />
                  {ReportFormatNumber(Number(item.monthlyRentPay))}
                </>
              )}
            </TableTd>
          </TableTr>
          <TableTr>
            <TableHeadTh width={'72px'}>
              전입/
              <br />
              확정/
              <br />
              배당
            </TableHeadTh>
            <TableTd width="80%">
              {' '}
              말소기준 :{' '}
              {appraisalInfo.lessee_date &&
                (appraisalInfo.lessee_date.match(/말소기준권리 :(.*?)\//) ||
                  [])[1]}{' '}
              <br />
              전입일자 : {item.regDate} <br />
              확정일자 : {item.confirmedDate} <br />
              배당요구 : {item.occupyYN} <br />
              배당요구종료일 :{' '}
              {appraisalInfo.lessee_date &&
                (appraisalInfo.lessee_date.match(/배당요구종기일 :(.*)/) ||
                  [])[1]}
            </TableTd>
          </TableTr>
          <TableTr>
            <TableHeadTh width={'72px'}>
              대항력/
              <br />
              기타
            </TableHeadTh>
            <TableTd width="80%">
              {item.is_resistance}
              {item.etc && item.etc !== '' && item.etc.trim().length > 1 ? (
                <>
                  /<br />
                  {item.etc}
                </>
              ) : (
                ''
              )}
            </TableTd>
          </TableTr>
        </tbody>
      );
    }
  };

  return (
    <Container id="임차인현황">
      <Title>
        <span>임차인현황</span>
        {type === 'a' && (
          <DataWrapper>
            <Description>
              <div>말소기준권리</div>
              <DateData>
                {(() => {
                  try {
                    const dateParts = appraisalInfo.lessee_date?.split('/');
                    if (!dateParts || dateParts.length === 0) return '-';

                    const keyValue = dateParts[0].split(': ');
                    return keyValue.length > 1 ? keyValue[1] : '-';
                  } catch (error) {
                    console.error('Error parsing lessee_date:', error);
                    return '-';
                  }
                })()}
              </DateData>
            </Description>
            <Divider />
            <Description>
              <div>배당요구중기일</div>
              <DateData>
                {(() => {
                  try {
                    const dateParts = appraisalInfo.lessee_date?.split('/');
                    if (!dateParts || dateParts.length === 0) return '-';

                    const keyValue = dateParts[1].split(': ');
                    return keyValue.length > 1 ? keyValue[1] : '-';
                  } catch (error) {
                    console.error('Error parsing lessee_date:', error);
                    return '-';
                  }
                })()}
              </DateData>
            </Description>
          </DataWrapper>
        )}
      </Title>
      <Content>
        {renterInfo.length > 0 &&
          renterInfo
            .slice(0, showAll ? renterInfo.length : 2)
            .map((item, index) => (
              <div style={{ width: '100%', overflowX: 'auto' }} key={index}>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  {renderData(item)}
                </table>
              </div>
            ))}
        {renterInfo.length > 2 && (
          <MoreButton
            onClick={() => {
              setShowAll((prev) => !prev);
            }}
          >
            <div>{showAll ? '닫기' : '더보기'}</div>
            <img
              style={{
                transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
              src="/assets/images/arrow/Arrow_down.png"
            ></img>
          </MoreButton>
        )}
      </Content>
      {type === 'a' && newRentNote.length > 0 && newRentNote[0] !== '-' && (
        <YellowBox>
          <img src="/assets/images/icon/warning.svg" alt="" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{ fontWeight: 700, fontSize: 18 }}>
              임차인 관련 주의사항
            </div>
            {newRentNote.map((item, index) => (
              <div key={index}>{item}</div>
            ))}
          </div>
        </YellowBox>
      )}
    </Container>
  );
};

export default TenantStatus;

export const PTenantStatus = ({ pRenterInfo, rentNote }: any) => {
  const { type } = useReportContext();
  const [showAll, setShowAll] = useState<boolean>(false);
  const PrentNoteArray = JSON.parse(pRenterInfo);
  const filteredPrentNoteArray = PrentNoteArray.filter(
    (arr: any) => arr.length > 0,
  );

  const renderPAuctionData = (item: any) => {
    if (item.length <= 1 || item[0].includes('없습니다')) {
      return (
        <tbody>
          <TableTr isFirst={true} isOneRow={true}>
            <TableHeadTh width={'72px'}>임차인</TableHeadTh>
            <TableHeadTh width={'72px'}>
              보증금/
              <br />
              차임(월세)
            </TableHeadTh>
            <TableHeadTh width={'72px'}>
              전입/
              <br />
              확정/
              <br />
              배당
            </TableHeadTh>
            <TableHeadTh width={'72px'}>
              대항력/
              <br />
              기타
            </TableHeadTh>
          </TableTr>
          <TableTr>
            <TableTd colSpan={4} width="80%">
              해당 내용 없음
            </TableTd>
          </TableTr>
        </tbody>
      );
    } else if (item.length === 0) {
      return (
        <tbody>
          <TableTr isFirst={true} isOneRow={true}>
            <TableHeadTh width={'72px'}>임차인</TableHeadTh>
            <TableHeadTh width={'72px'}>
              보증금/
              <br />
              차임(월세)
            </TableHeadTh>
            <TableHeadTh width={'72px'}>
              전입/
              <br />
              확정/
              <br />
              배당
            </TableHeadTh>
            <TableHeadTh width={'72px'}>
              대항력/
              <br />
              기타
            </TableHeadTh>
          </TableTr>
          <TableTr>
            <TableTd colSpan={4} width="80%">
              해당 내용 없음
            </TableTd>
          </TableTr>
        </tbody>
      );
    } else {
      return (
        <tbody>
          <TableTr isFirst={true}>
            <TableHeadTh width={'72px'}>임차인</TableHeadTh>
            <TableTd rowSpan={1} width="80%">
              {item[1]}
            </TableTd>
          </TableTr>
          <TableTr>
            <TableHeadTh width={'72px'}>
              보증금
              <br />
              /차임
              <br />
              (월세)
            </TableHeadTh>
            <TableTd width="80%">
              {item[2] === '-' && item[3] === '-' ? (
                '-'
              ) : (
                <>
                  {ReportFormatNumber(Number(item[2].replace(/,/g, '')))}/{' '}
                  <br />
                  {ReportFormatNumber(Number(item[3]))}
                </>
              )}
            </TableTd>
          </TableTr>
          <TableTr>
            <TableHeadTh width={'72px'}>
              전입/
              <br />
              확정/
              <br />
              배당
            </TableHeadTh>
            <TableTd width="80%">
              전입일자 : {item[6]} <br />
              확정일자 : {item[5]} <br />
              {/* 배당요구 : {item.occupyYN} <br /> */}
            </TableTd>
          </TableTr>
          <TableTr>
            <TableHeadTh width={'72px'}>
              대항력/
              <br />
              기타
            </TableHeadTh>
            <TableTd width="80%">
              {item.is_resistance}
              {item.etc && item.etc !== '' && item.etc.trim().length > 1 ? (
                <>
                  /<br />
                  {item.etc}
                </>
              ) : (
                item[0]
              )}
            </TableTd>
          </TableTr>
        </tbody>
      );
    }
  };
  return (
    <Container id="임차인현황">
      <Title>
        <span>임차인현황</span>
        <DescriptionBox>감정평가서 및 신고된 임대차 기준</DescriptionBox>
      </Title>
      <Content>
        {filteredPrentNoteArray.length > 0 &&
          filteredPrentNoteArray
            .slice(0, showAll ? filteredPrentNoteArray.length : 2)
            .map((item: any, index: any) => (
              <div style={{ width: '100%', overflowX: 'auto' }} key={index}>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  {renderPAuctionData(item)}
                </table>
              </div>
            ))}
        {filteredPrentNoteArray.length > 2 && (
          <MoreButton
            onClick={() => {
              setShowAll((prev) => !prev);
            }}
          >
            <div>{showAll ? '닫기' : '더보기'}</div>
            <img
              style={{
                transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
              src="/assets/images/arrow/Arrow_down.png"
            ></img>
          </MoreButton>
        )}
        {filteredPrentNoteArray.length === 0 && (
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            {renderPAuctionData('')}
          </table>
        )}
      </Content>
      {PrentNoteArray.length > 0 &&
        PrentNoteArray[1] &&
        !PrentNoteArray[1][0].includes('없습니다') && (
          <YellowBox>
            <img src="/assets/images/icon/warning.svg" alt="" />
            <div>
              임대차정보는 감정서상 표시내용 또는 신고된 임대차 내용으로서 누락,
              추가, 변동 될 수 있으니 참고 자료로만 활용하여야 하며, 이에 따른
              모든 책임은 입찰자에게 있습니다. 임차인의 배분요구 여부는 입찰시작
              7일전부터 제공하는 공매재산명세서를 통하여 확인하시기 바랍니다.
            </div>
          </YellowBox>
        )}
    </Container>
  );
};

const DescriptionBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  color: #616161;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  border: 1px solid #e8e9ea;
  padding: 12px 16px;
  border-radius: 8px;
`;

interface WidthProps {
  width: string;
}

interface TableTrProps {
  isFirst?: boolean;
  isOneRow?: boolean;
}

const MoreButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 4px;
  color: black;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 400;
  line-height: 18.85px;
  word-wrap: break-word;
  border-radius: 4px;
  border: 1px #e1e2e4 solid;

  img {
    width: 16px;
    height: 16px;
  }
`;

const TableTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
  letter-spacing: -0.32px;
`;

const TableTr = styled.tr<TableTrProps>`
  width: 100%;
  border-top: ${({ isFirst }) => (isFirst ? '1px solid #616161' : 'none')};
  border-bottom: ${({ isOneRow }) => (isOneRow ? 'none' : '1px solid #e8e9ea')};
`;

const TableHeadTh = styled.th<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  // border: 1px solid #e8e9ea;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: 'Spoqa Han Sans Neo';
  letter-spacing: -0.36px;
  color: #616161;
  font-size: 13px;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
`;

const ContentInner = styled.div`
  width: 100%;
  display: flex;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e8e9ea;
`;

const DataWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid #e8e9ea;
  padding: 12px 16px;
  border-radius: 8px;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: white;
  padding: 32px 16px;
`;

const Title = styled.div`
  width: 100%;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 31.9px */
  letter-spacing: -0.44px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
`;

const DateData = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const Description = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  color: #616161;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  letter-spacing: -0.32px;

  div {
    width: 83px;
  }
`;
const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border: 1px solid #e8e9ea;
  padding: 6px 0;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #171e26;
`;
const YellowBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(250, 177, 47, 0.1);
  border-radius: 8px;
  padding: 16px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #a86c00;
`;
